import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileBottomNav.css';

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const active = (routes) =>
    routes.some(r => (r === '/' ? path === '/' : path.startsWith(r)))
      ? 'active'
      : '';

  return (
    <div className="m-ali-bnav">
      {/* Home */}
      <button className={`m-ali-bnav-item ${active(['/'])}`} onClick={() => navigate('/')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        <span>Home</span>
      </button>

      {/* Categories */}
      <button className={`m-ali-bnav-item ${active(['/all-categories'])}`} onClick={() => navigate('/all-categories')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7" rx="1"/>
          <rect x="14" y="3" width="7" height="7" rx="1"/>
          <rect x="3" y="14" width="7" height="7" rx="1"/>
          <rect x="14" y="14" width="7" height="7" rx="1"/>
        </svg>
        <span>Categories</span>
      </button>

      {/* Messenger */}
      <button className={`m-ali-bnav-item ${active(['/messages', '/mobile/messenger'])}`} onClick={() => navigate('/mobile/messenger')}>
        <span style={{ position: 'relative', display: 'inline-flex' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          <span className="m-ali-bnav-dot">1</span>
        </span>
        <span>Messenger</span>
      </button>

      {/* Cart */}
      <button className={`m-ali-bnav-item ${active(['/mobile/cart'])}`} onClick={() => navigate('/mobile/cart')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="9" cy="21" r="1"/>
          <circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
        </svg>
        <span>Cart</span>
      </button>

      {/* My Alibaba */}
      <button className={`m-ali-bnav-item ${active(['/mobile/alibaba'])}`} onClick={() => navigate('/mobile/alibaba')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
        <span>My Alibaba</span>
      </button>
    </div>
  );
}
